module.exports = __webpack_public_path__ + "static/sarah-group-008938814bc28fead112c82e9c5e5cf2.jpg";